import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "popper.js";
import "./assets/app.scss";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import * as bFormSlider from "vue-bootstrap-slider";
import * as fullscreen from "vue-fullscreen";
import * as VueHtml2pdf from "vue-html2pdf";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { BCollapse } from "bootstrap-vue";
import Multiselect from "vue-multiselect";
import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import VueIframe from "vue-iframes";
import JsonExcel from "vue-json-excel";
import DisablePasteMixin from './disablePasteMixin';

import VueCountryCode from "vue-country-code";

Vue.use(VueCountryCode);



Vue.use(VueSidebarMenu);
Vue.component("b-collapse", BCollapse);
Vue.component("loading-overlay", Loading);
Vue.component("multiselect", Multiselect);
Vue.component("exportFromJSON", JsonExcel);
Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(VueHtml2pdf);
Vue.use(fullscreen);
Vue.use(bFormSlider);
Vue.use(VueIframe);
Vue.mixin(DisablePasteMixin);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
